<template>
  <div class="about-us max-w-4xl mx-auto">
    <div class="glass-card p-8">
      <!-- 헤더 -->
      <div class="text-center mb-8">
        <div class="text-4xl mb-3">🎯</div>
        <h1 class="text-3xl font-bold text-gradient mb-2">로또 지니어스 소개</h1>
        <p class="text-gray-600">재미있는 로또 번호 선택 체험 플랫폼</p>
      </div>

      <!-- 미션 -->
      <section class="mb-8">
        <div class="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
          <h2 class="text-2xl font-bold mb-4 flex items-center">
            <span class="text-3xl mr-3">🌟</span>
            우리의 미션
          </h2>
          <p class="text-gray-700 text-lg leading-relaxed">
            로또 지니어스는 <strong class="text-blue-600">재미있고 교육적인 로또 번호 선택 경험</strong>을 제공하는 
            엔터테인먼트 플랫폼입니다. 우리는 로또의 진정한 확률을 정직하게 알리면서도, 
            번호 선택 과정 자체를 즐거운 체험으로 만들고자 합니다.
          </p>
        </div>
      </section>

      <!-- 핵심 가치 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">핵심 가치</h2>
        <div class="grid md:grid-cols-3 gap-4">
          <div class="bg-white p-5 rounded-xl shadow-md border border-gray-100">
            <div class="text-3xl mb-3">🎪</div>
            <h3 class="font-bold text-lg mb-2">엔터테인먼트 우선</h3>
            <p class="text-gray-600 text-sm">
              당첨보다는 선택하는 과정의 재미에 집중합니다. 
              AI 친구들과 다양한 패턴으로 창의적인 번호 조합을 만드세요.
            </p>
          </div>
          
          <div class="bg-white p-5 rounded-xl shadow-md border border-gray-100">
            <div class="text-3xl mb-3">📚</div>
            <h3 class="font-bold text-lg mb-2">정직한 교육</h3>
            <p class="text-gray-600 text-sm">
              모든 번호 조합의 당첨 확률이 1/8,145,060로 동일하다는 사실을 
              명확히 알립니다. 확률 교육이 우리의 책임입니다.
            </p>
          </div>
          
          <div class="bg-white p-5 rounded-xl shadow-md border border-gray-100">
            <div class="text-3xl mb-3">🛡️</div>
            <h3 class="font-bold text-lg mb-2">책임있는 서비스</h3>
            <p class="text-gray-600 text-sm">
              과도한 로또 구매를 조장하지 않으며, 
              사용자가 즐거움과 책임감 사이의 균형을 유지하도록 돕습니다.
            </p>
          </div>
        </div>
      </section>

      <!-- 서비스 특징 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">서비스 특징</h2>
        <div class="space-y-4">
          <div class="bg-green-50 p-5 rounded-xl border-l-4 border-green-400">
            <h3 class="font-bold text-lg mb-2 flex items-center">
              <span class="text-2xl mr-2">🤖</span>
              5명의 개성있는 AI 친구들
            </h3>
            <p class="text-gray-700 text-sm">
              Luna, Pablo, Melody, Archie, Morph - 각각 다른 성격과 알고리즘을 가진 
              AI 캐릭터들이 재미있는 번호 조합을 만들어줍니다. LSTM, GAN, Transformer, CNN, VAE 등 
              최신 머신러닝 기술을 활용했지만, 이 모든 것은 순전히 재미를 위한 것입니다.
            </p>
          </div>

          <div class="bg-purple-50 p-5 rounded-xl border-l-4 border-purple-400">
            <h3 class="font-bold text-lg mb-2 flex items-center">
              <span class="text-2xl mr-2">🎨</span>
              다양한 패턴 생성기
            </h3>
            <p class="text-gray-700 text-sm">
              피보나치 수열, 소수, 하트 모양, 별 모양 등 수학적·시각적 아름다움을 담은 
              15가지 이상의 패턴으로 독특한 번호 조합을 만들 수 있습니다. 
              메가 콤보 패턴으로 여러 패턴을 조합해보세요!
            </p>
          </div>

          <div class="bg-blue-50 p-5 rounded-xl border-l-4 border-blue-400">
            <h3 class="font-bold text-lg mb-2 flex items-center">
              <span class="text-2xl mr-2">📊</span>
              통계 분석 및 시각화
            </h3>
            <p class="text-gray-700 text-sm">
              1회차부터 최신 회차까지 1000회 이상의 로또 데이터를 분석하고 
              아름다운 차트로 시각화합니다. 과거 패턴을 관찰하는 재미는 있지만, 
              미래를 예측할 수는 없다는 것을 기억하세요.
            </p>
          </div>

          <div class="bg-yellow-50 p-5 rounded-xl border-l-4 border-yellow-400">
            <h3 class="font-bold text-lg mb-2 flex items-center">
              <span class="text-2xl mr-2">🎓</span>
              확률 교육 콘텐츠
            </h3>
            <p class="text-gray-700 text-sm">
              당첨 확률, 기댓값, 통계적 오해 등을 쉽고 재미있게 설명합니다. 
              로또를 즐기면서도 그 본질을 정확히 이해하는 것이 중요합니다.
            </p>
          </div>
        </div>
      </section>

      <!-- 기술 스택 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">기술 스택</h2>
        <div class="bg-gray-50 p-6 rounded-xl">
          <div class="grid md:grid-cols-2 gap-6">
            <div>
              <h3 class="font-bold mb-3 flex items-center">
                <span class="text-xl mr-2">⚡</span>
                Frontend
              </h3>
              <ul class="space-y-2 text-sm text-gray-700">
                <li>• Vue.js 3 (Composition API)</li>
                <li>• Vite (빠른 빌드 도구)</li>
                <li>• Tailwind CSS (모던 스타일링)</li>
                <li>• Chart.js (데이터 시각화)</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold mb-3 flex items-center">
                <span class="text-xl mr-2">🤖</span>
                AI & Data
              </h3>
              <ul class="space-y-2 text-sm text-gray-700">
                <li>• TensorFlow.js (머신러닝)</li>
                <li>• 5가지 AI 모델 (LSTM, GAN, CNN, VAE, Transformer)</li>
                <li>• 동행복권 공식 API 연동</li>
                <li>• GitHub Actions 자동화</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- 우리가 하지 않는 것 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-red-600">우리가 하지 않는 것 ⚠️</h2>
        <div class="bg-red-50 p-6 rounded-xl border-2 border-red-200">
          <ul class="space-y-3 text-gray-700">
            <li class="flex items-start">
              <span class="text-red-500 mr-2">❌</span>
              <div>
                <strong>당첨 보장 또는 확률 향상 주장</strong>
                <p class="text-sm text-gray-600">
                  우리는 어떤 방법도 당첨 확률을 높일 수 없다는 사실을 명확히 합니다.
                </p>
              </div>
            </li>
            <li class="flex items-start">
              <span class="text-red-500 mr-2">❌</span>
              <div>
                <strong>유료 서비스 또는 구독</strong>
                <p class="text-sm text-gray-600">
                  로또 지니어스는 완전 무료이며, 앞으로도 그럴 것입니다.
                </p>
              </div>
            </li>
            <li class="flex items-start">
              <span class="text-red-500 mr-2">❌</span>
              <div>
                <strong>개인정보 수집 (회원가입 없음)</strong>
                <p class="text-sm text-gray-600">
                  회원가입이 필요없으며, 이름·전화번호 등 민감 정보를 수집하지 않습니다.
                </p>
              </div>
            </li>
            <li class="flex items-start">
              <span class="text-red-500 mr-2">❌</span>
              <div>
                <strong>과도한 구매 조장</strong>
                <p class="text-sm text-gray-600">
                  우리는 책임있는 로또 참여를 권장하며, 과도한 구매를 조장하지 않습니다.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <!-- 데이터 소스 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">데이터 소스</h2>
        <div class="bg-indigo-50 p-6 rounded-xl">
          <p class="text-gray-700 mb-4">
            로또 지니어스는 <strong class="text-indigo-600">동행복권 공식 API</strong>를 통해 
            로또 당첨번호 데이터를 수집합니다.
          </p>
          <ul class="space-y-2 text-sm text-gray-700 ml-4">
            <li>• 출처: 동행복권 공식 API (www.dhlottery.co.kr)</li>
            <li>• 업데이트: 매일 자동 수집 (GitHub Actions)</li>
            <li>• 데이터 범위: 1회차부터 최신 회차까지</li>
            <li>• 정확성: 공식 데이터를 그대로 사용하나, 동행복권 사이트가 최종 권위입니다</li>
          </ul>
        </div>
      </section>

      <!-- 팀 소개 -->
      <section class="mb-8">
        <h2 class="text-2xl font-bold mb-6 text-blue-600">팀 소개</h2>
        <div class="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl">
          <p class="text-gray-700 mb-4">
            로또 지니어스는 <strong>재미와 교육의 균형</strong>을 추구하는 개발자들이 만든 프로젝트입니다.
          </p>
          <p class="text-gray-700 mb-4">
            우리는 AI와 머신러닝 기술을 활용하되, 이것이 당첨을 보장하지 않는다는 사실을 
            명확히 하는 것이 진정한 책임있는 서비스라고 믿습니다.
          </p>
          <div class="bg-white p-4 rounded-lg mt-4">
            <p class="text-sm text-gray-600 italic">
              "로또는 운의 게임입니다. 하지만 그 과정은 재미있고 창의적일 수 있습니다. 
              우리는 바로 그 재미를 제공합니다."
            </p>
          </div>
        </div>
      </section>

      <!-- 연락처 안내 -->
      <section>
        <div class="bg-blue-50 p-6 rounded-xl text-center">
          <h3 class="font-bold text-lg mb-3">문의 및 제안</h3>
          <p class="text-gray-700 mb-4">
            서비스 개선 제안, 버그 리포트, 기타 문의사항이 있으시면 
            연락처 페이지를 통해 알려주세요.
          </p>
          <p class="text-sm text-gray-500">
            여러분의 피드백이 로또 지니어스를 더 재미있게 만듭니다!
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
// 스크립트가 필요하면 추가
</script>

<style scoped>
.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glass-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
}

section {
  scroll-margin-top: 100px;
}
</style>
